import {Component} from '@angular/core';

@Component({
    selector: 'tfl-arrow-left-icon',
    template: `        
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12">
            <path fill="#839BA7" fill-rule="evenodd" d="M6.14.349a.586.586 0 0 1 .827.007.577.577 0 0 1 0 .821L2.774 5.372l13.877.034a.586.586 0 0 1 .003 1.173l-13.872-.04 4.21 4.21a.588.588 0 1 1-.83.83L.952 6.372A.591.591 0 0 1 .95 5.54L6.14.349z"/>
        </svg>
    `
})
export class ArrowLeftIcon {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/arrow.left.icon.ts